// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_2b-1";
export var rateTableServiceLevelDropdown = "_2b-3";
export var rateTableTypeDropdown = "_2b-0";
export var rateTableValueModeDropdown = "_2b-2";